import './styles.scss';
import React from 'react';
import { Button, Col, Modal, Row } from 'reactstrap';
import ImageCarousel from './ImageCarousel';
import { Product } from '~domain/product/Product';
import { ProductType } from '~types/api';
import { formatCurrency } from '~utils/formatter';
import { getPublicImageUrl } from '~utils/image';
import { getProductTypeString } from '~utils/product';

type ProductDetailModalProps = {
  product: Product;
  productType?: ProductType;
  isOpen: boolean;
  toggle: () => void;
};

const ProductDetailModal: React.FC<ProductDetailModalProps> = ({
  product,
  productType,
  isOpen,
  toggle,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      contentClassName="rounded-0 p-0 h-100 product-detail-modal"
    >
      <Button
        close
        onClick={toggle}
        style={{ position: 'absolute', top: 10, right: 20, zIndex: 1000 }}
      />
      <Row className="m-0 product-detail-modal-inner">
        <Col xs={12} lg={6} className="p-0">
          <div
            style={{
              width: '100%',
              height: 0,
              paddingTop: '100%',
              position: 'relative',
            }}
          >
            <ImageCarousel
              images={[
                ...(productType?.imageKey
                  ? [getPublicImageUrl(productType?.imageKey, 'large')]
                  : []),
                ...((
                  (product as any).imageKeys?.items ?? product.imageKeys
                )?.map((item: any) =>
                  getPublicImageUrl(item.imageKey, 'large')
                ) ?? []),
              ]}
            />
          </div>
        </Col>
        <Col xs={12} lg={6} className="product-details p-5">
          <div className="d-flex flex-column align-items-between mb-4">
            <p className="mb-0" translate="no">
              {product.brand.brand_name}
            </p>
            <div>
              <h5 className="mb-0 font-weight-bold">{product.product_name}</h5>
              {productType && (
                <p className="mb-0">{getProductTypeString(productType)}</p>
              )}
            </div>
            <div className="mb-0">
              {product.isSaleProduct && (
                <s className="mr-2">
                  {formatCurrency(product.originalUnitPrice)}
                </s>
              )}
              <span className={product.isSaleProduct ? 'text-danger' : ''}>
                {formatCurrency(product.unitPrice)}
                {!product.is_open_price && (
                  <span>（{product.wholesaleRate}%）</span>
                )}
              </span>
              {!product.is_open_price && (
                <span className="ml-2 text-muted">
                  上代 {formatCurrency(product.product_retail_price)}
                </span>
              )}
              {product.is_open_price && (
                <span className="ml-2 text-muted">オープン価格</span>
              )}
            </div>
          </div>
          <p>
            <b>商品概要</b>
            <div>{product.product_content}</div>
          </p>
          <p>
            <b>商品詳細</b>
            <div>{product.product_description}</div>
          </p>
          <p>
            <b>サイズ詳細</b>
            <div>{product.product_size}</div>
          </p>
        </Col>
      </Row>
    </Modal>
  );
};

export default ProductDetailModal;
